import Status from 'clarks/components/ivu-table/status'

let exports = {
   options_form:{
      forms:[
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'val',
            validation: 'required|min:3|max:300', label: 'Code', placeholder: 'Change with caution',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'label',
            validation: 'required|min:3|max:300', label: 'Label'
         }
      ],
      table:{
         icon: 'fa fa-sitemap',
         title: 'Options',
         table_fields: [
            { name: 'Code', align: 'c' },
            { name: 'Label', align: 'c' },
            { name: 'Actions', align: 'c' }
         ],
         search_fields: ["val", "label"],
         row_data: [
            { type: 'text', field: 'val', class: 'bold center' },
            { type: 'text', field: 'label', class: 'small center' },
            {
               type: 'action', field: 'name', class: 'center', icon: '', actions: [
                  // {type: 'title', title: 'Actions'},
                  { type: 'menu', title: 'View', event: 'table:view' },
                  { type: 'menu', title: 'Delete', event: 'table:delete', icon: 'fa-trash-alt' },
               ]
            },
         ]
      }
   }
}

let forms = {
   addFilter: {
      icon: 'fa fa-university',
      title: 'Add Filter',
      subtitle: 'Provide Filter Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "name", label: "Name", },
         { 
            type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, validation: "required", model: "type", label: "Type",
            options: [
               { val: "select", label: "Select", },
               { val: "number", label: "Number", },
            ]
         }, 
         { type: "select", class: "col-12 col-md-6", filterable: true, clearable: true, options: [], validation: "required", model: "table", label: "Table", },
         { type: "select", class: "col-12 col-md-6", filterable: true, clearable: true, options: [], validation: "required", model: "field", label: "Field", },
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "has_multiple", label: "Has Multiple", },
         { type: "textarea", class: "col-12", rows: "4", validation: "required", model: "description", label: "Description", },
      ]
   },
   editFilter: {
      icon: 'fa fa-university',
      title: 'Edit Filter',
      subtitle: 'Update Filter Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "name", label: "Name", },
         { 
            type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, validation: "required", model: "type", label: "Type",
            options: [
               { val: "select", label: "Select", },
               { val: "number", label: "Number", },
            ]
         }, 
         { type: "select", class: "col-12 col-md-6", filterable: true, clearable: true, options: [], validation: "required", model: "table", label: "Table", },
         { type: "select", class: "col-12 col-md-6", filterable: true, clearable: true, options: [], validation: "required", model: "field", label: "Field", },
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "has_multiple", label: "Has Multiple", },
         { type: "textarea", class: "col-12", rows: "4", validation: "required", model: "description", label: "Description", },
      ]
   },
   edit_options: {
      icon: 'fa fa-university',
      title: 'Edit Options',
      subtitle: 'Update Options',
      forms: [
         {
            type: 'form-table', forms: exports.options_form.forms, table: exports.options_form.table, label: 'Options', model: 'options', class: 'col-12'
         }
      ]
   },
}

let tables = {
   filter: {
      props: {
         icon: 'fa fa-database',
         title: 'Filter',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['name', 'field', 'type', 'table', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Name", key: "name", },
            { title: "Field", key: "field", },
            { title: "Type", key: "type", },
            { title: "Table", key: "table", },

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'filter:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Fetch Options', event: 'filter:fetch_options', icon: 'fa-align-left', allow_multiple: true },
            // { type: 'menu', title: 'Edit Options', event: 'filter:edit_options', icon: 'fa-pencil-alt', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'filter:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}